import { API } from '../../Services/Api';

const request = new API();

export const refreshToken = (data) => request.api.post('auth/token/refresh/', data);

export const verifyToken = ({ token }) => request.api.post('auth/token/verify/', {token});
